<template>
<div>
    <invoice-form ref="invoiceFormModal"></invoice-form>
    <b-row class="align-items-center">
        <b-col class="d-flex align-items-center col-lg-8">
            <b-col class="col-2">
                <label for="lawyer-Invoice-report-start-date-input"> {{ $t('lawyerInvoiceReport.start_date') }} </label>
                <b-form-datepicker id="lawyer-Invoice-report-start-date-input" today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('lawyerInvoiceReport.start_date')" size="sm" v-model="startDate" class="mb-1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-2">
                <label for="lawyer-Invoice-report-end-date-input"> {{ $t('lawyerInvoiceReport.end_date') }} </label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('lawyerInvoiceReport.end_date')" size="sm" v-model="endDate" class="mb-1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-2 mb-1">
                <label for="lawyer-Invoice-report-lawyer-input">{{ $t('lawyerInvoiceReport.lawyer') }}</label>
                <b-form-select @change="getLawyerInvoiceReportList()" id="lawyer-Invoice-report-lawyer-input" :placeholder="$t('lawyerInvoiceReport.lawyer')" size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
            </b-col>
            <b-col class="col-2 mb-1">
                <label for="lawyer-Invoice-report-currency-input">{{ $t('lawyerInvoiceReport.currency') }}</label>
                <b-form-select @change="getLawyerInvoiceReportList()" id="lawyer-Invoice-report-currency-input" :placeholder="$t('lawyerInvoiceReport.currency')" size="sm" v-model="currencySelect" value-field="id" text-field="name" :options="currencyOption" />
            </b-col>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-4">
            <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getLawyerInvoiceReportList()" v-on:keyup.enter="getLawyerInvoiceReportList()">{{ $t('others.list') }}</b-button>
            <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('others.excel') }}</b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="lawLawyerInvoiceReportTable" ref="lawLawyerInvoiceReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'employee'" class="text-nowrap">
                {{ $t('lawyerInvoiceReport.lawyer') }}
            </span>
            <span v-else-if="props.column.field === 'debit_no'" class="text-nowrap">
                {{ $t('lawyerInvoiceReport.debitNo') }}
            </span>
            <span v-else-if="props.column.field === 'invoiceDate'" class="text-nowrap">
                {{ $t('lawyerInvoiceReport.invoice_date') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('lawyerInvoiceReport.currency') }}
            </span>
            <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                {{ $t('lawyerInvoiceReport.total') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInvoiceInfo(props.row.lawInvoiceId)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getLawyerInvoiceReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            dir: false,
            pageLength: 10,
            pageNo: 1,
            startDate: '',
            endDate: '',
            columns: [{
                    label: this.$t('lawyerInvoiceReport.employee'),
                    field: `employee`,
                },
                {
                    label: this.$t('lawyerInvoiceReport.agent'),
                    field: `agent`,
                },
                {
                    label: this.$t('lawyerInvoiceReport.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('lawyerInvoiceReport.invoice_date'),
                    field: `invoiceDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('lawyerInvoiceReport.currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('lawyerInvoiceReport.total'),
                    field: `total`,
                    formatFn: this.$formatMoney,
                },
                {
                    label: this.$t('lawyerInvoiceReport.invoice_status'),
                    field: `lawInvoiceStatus`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            total: 0,
            employeeSelect: 0,
            employeeOption: [],
            currencySelect: 0,
            currencyOption: []
        }
    },
    computed: {},
    mounted() {
        this.getLawyerInvoiceReportList()
    },
    methods: {
        getLawyerInvoiceReportList() {
            if (this.startDate == '') {
                this.startDate = new Date()
            }
            if (this.endDate == '') {
                this.endDate = new Date()
            }
            this.rows = []
            const controller = {
                name: 'LawReport',
                actionName: 'GetLawLawyerInvoiceReportList'
            }
            const data = {
                startDate: this.startDate,
                endDate: this.endDate,
                employeeId: this.employeeSelect,
                pageLength: this.pageLength,
                currencyId: this.currencySelect,
                pageNo: this.pageNo
            }
            const payload = {
                controller: controller,
                data: data
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.lawLawyerInvoiceReportList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.total = response.data.total
                    this.employeeOption = response.data.lawEmployeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())

                    this.currencyOption = response.data.currencyList
                    this.currencyOption.splice(0, 0, this.$nullSelected())

                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async getInvoiceInfo(id) {
            this.$refs.invoiceFormModal.showInfo(id)
        },
        exportExcel() {
            const controller = {
                name: 'LawReport',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Avukat Fatura Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },

}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
